module.exports = __webpack_public_path__ + "static/img/system-1.7ff4e6b8.png";